"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMeasure = void 0;
/**
 * @summary Formats a measure as a string.
 *
 * Formats a measure as a string. The value is formatted with thousands separators and in a locale-aware format with
 * the minimum and maximum number of fractional digits specified in the options. The unit is appended to the value
 * with a narrow non-breaking space by default so that it does not separate from the value.
 *
 * @param {Measure} measure
 * @param {string | undefined} language
 * @param {FormatMeasureOptions | undefined} options
 * @returns {string}
 */
function formatMeasure(measure, language, options) {
    const spacer = options?.unitSpacer ?? '\u202f';
    return `${measure.value.toLocaleString(language, options)}${spacer}${measure.unit}`;
}
exports.formatMeasure = formatMeasure;
